module.exports = __webpack_public_path__ + "media/snow-zone.d876d094.mp3";